import { each, go, last } from "fxjs/es";
import { PathEditorNS } from "../../../../../../PathEditor/PathEditorNS.js";
import { BaseNS } from "../../Base/BaseNS.js";
export const _handleMouseMove = (self, event) => {
  if (!self._is_mouse_down) {
    return;
  }
  const outer_cutting_line_clip_path_el =
    self._getOuterCuttingLineClipPathElThrowable();
  const outer_cutting_line_display_path_el =
    self._getOuterCuttingLineDisplayPathElThrowable();
  const prev_mouse_move_position = self._mouse_move_position;
  const { clientX: client_x, clientY: client_y } = event;
  const point = self.toViewPortPoint({
    x: client_x,
    y: client_y,
  });
  self._is_mouse_move = true;
  self._mouse_move_position = {
    x: point.x,
    y: point.y,
  };
  switch (self._processing_task) {
    case BaseNS.PROCESSING_TASK.PATH_EDITING_TRANSLATE_TRANSFORMING: {
      const _ctm = outer_cutting_line_display_path_el.getCTM();
      if (_ctm == null) {
        return;
      }
      const ctm = _ctm;
      const transform = self._svg_el.createSVGTransform();
      transform.setTranslate(
        self._mouse_move_position.x - prev_mouse_move_position.x,
        self._mouse_move_position.y - prev_mouse_move_position.y
      );
      const matrix = ctm.inverse().multiply(transform.matrix).multiply(ctm);
      each(({ model }) => {
        model.transform(matrix);
      })(self._path_editor_list);
      const d = go(
        self._path_editor_list,
        last,
        (a) => a?.model,
        (m) => m?.toString()
      );
      if (d != null) {
        self._outer_cutting_line_path_data = d;
        outer_cutting_line_clip_path_el.setAttributeNS(null, "d", d);
        outer_cutting_line_display_path_el.setAttributeNS(null, "d", d);
        outer_cutting_line_clip_path_el.dispatchEvent(
          new CustomEvent("@mp/sticker-editor/outer-cutting-line-changed", {
            bubbles: true,
            cancelable: true,
            composed: false,
            detail: {
              path_data: d,
            },
          })
        );
      }
      return;
    }
    default: {
      return;
    }
  }
};
